// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderTabsMenu_wrapper__16Imt","inner":"HeaderTabsMenu_inner___PSiO"};